import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';

export function useThemeFromRedux() {
  const block = useSelector((state: RootState) => state.block.block);
  const selectedThemeId = useSelector((state: RootState) => state.theme.selectedThemeId);

  if (!block) {
    return null;
  }

  const selectedTheme = selectedThemeId
    ? block.themes.find((theme) => theme.id === selectedThemeId)
    : block.themes[0];

  if (!selectedTheme) {
    return null;
  }

  return {
    color: {
      1: block.style[1],
      2: block.style[2],
      3: block.style[3],
      4: block.style[4],
      5: block.style[5],
      6: block.style[6],
      7: block.style[7],
      white: '#ffffff',
      warningRed: '#ff0000',
    },
    typography: {
      REGULAR_12: css`
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
      `,
      REGULAR_16: css`
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      `,
      REGULAR_24: css`
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
      `,
      REGULAR_30: css`
        font-size: 30px;
        font-weight: 400;
        line-height: 45px;
      `,
      MEDIUM_16: css`
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      `,
      SEMI_BOLD_24: css`
        font-size: 24px;
        font-weight: 600;
        line-height: 36px;
      `,
      SEMI_BOLD_48: css`
        font-size: 48px;
        font-weight: 600;
        line-height: 72px;
      `,
      BOLD_36: css`
        font-size: 36px;
        font-weight: 700;
        line-height: 54px;
      `,
      BOLD_60: css`
        font-size: 60px;
        font-weight: 700;
        line-height: 90px;
      `,
      BOLD_72: css`
        font-size: 72px;
        font-weight: 700;
        line-height: 108px;
      `,
    },
  };
}
